import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { breakpoints, spacing } = redesignTheme;

export const useProfileEditStyles = makeStyles(() => ({
  page: {
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      paddingLeft: 80,
      paddingRight: 80,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
    width: '100%',
  },
  skeletonBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
}));
